import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";

//Custom components
import { CustomTab, Loader, OverLay } from '../../../Component/Others';
import { DataTableComponent } from '../../../Component/DataTable';
import { EmptyScreen } from '../../../Component/EmptyComponent';
import { DownloadButton, PrimaryButton, SecondaryButton, TextButton } from '../../../Component/Buttons';
import { CustomDatePicker, CustomSelectBox } from '../../../Component/FormElements';
import { APIService } from '../../../Service'
import { AddRewardsModal, ConfirmDeleteModal, PauseRewardModal } from '../../../Component/Modal';

import styles from "../../../Style/Component/input.module.scss";
import { Modal } from 'bootstrap';
import { useSelector } from 'react-redux';
import Store from '../../../Store/store';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { Icon } from '../../../Component/Icon';



const FILTER_DATA = [
    {
        value: null,
        label: "All"
    },
    {
        value: 1,
        label: "Active"
    },
    {
        value: 2,
        label: "Inactive"
    }
];

const TAB_DATA = [
    {
        id: 1,
        label: "Rewards"
    },
    {
        id: 2,
        label: "Manage Rewards Points"
    },
    {
        id: 3,
        label: "Rewards Settings"
    },
];

const ROWS_PER_PAGE = 20;

const REWARD_SORT_FIELDS = [
    'brand_title',
    'title',
    'offer_id',
    'total_redeemed_users',
    'status',
    'currency',
    'validity_in_months',
];

const RewardList = () => {
    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const navigate = useNavigate();
    const { state } = useLocation();
    const scrollRef = useRef(null);
    const isSortingRef = useRef(false);
    const skipListFetchRef = useRef(false);

    const [adminType, setAdminType] = useState(Cookies.get("admin_type") === "1" ? "super_admin" : "country_admin");

    const [listData, setListData] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);

    const [toggleFilter, setToggleFilter] = useState(false);

    const [status, setStatus] = useState(FILTER_DATA[0]);

    const [pauseModal, setPauseModal] = useState(false);

    const [isPause, setIsPause] = useState(false);

    const [tabIndex, setTabIndex] = useState(0);

    const [milestoneFilterData, setMilestoneFilterData] = useState({});
    const [milestoneModal, setMilestoneModal] = useState(false);
    const [milestoneData, setMilestoneData] = useState({});
    // const [currentPageMilestone, setCurrentPageMileStone] = useState(1);
    // const [loading., setLoading] = useState(true);
    const [deleteResponse, setDeleteResponse] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [milestoneOptions, setMilestoneOptions] = useState([]);
    const [selected, setSelected] = useState(null);
    const [clearFilter, setClearFilter] = useState(false);

    const [downloadLoader, setDownloadLoader] = useState(false);


    const [selectedDay, setSelectedDay] = useState(null);
    const [dateToggle, setDateToggle] = useState(false);

    const [endDate, setEndDate] = useState(null);
    const [endDateToggle, setEndDateToggle] = useState(false);

    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);

    // Rewards settings - point conversion rule
    const [settingsList, setSettingsList] = useState([]);
    const [saveLoaderIndex, setSaveLoaderIndex] = useState(null);


    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        _getMilestoneFilter();
    }, []);

    useEffect(() => {
        if (PROFILE_DATA.reward_enabled === false) {
            setIsPause(true);
        }
    }, [PROFILE_DATA]);


    useEffect(() => {

        if (state !== null) {
            if (state?.current_page) {
                setCurrentPage(state.current_page)
            } else {
                setCurrentPage(1);
            }
            if (state?.status) {
                setStatus(state.status)
            } else {
                setStatus(FILTER_DATA[0]);
            }
            if (state?.toggle) {
                setToggleFilter(state.toggle)
            } else {
                setToggleFilter(false);
            }

            if (state.tab_index) {
                setTabIndex(state.tab_index);
            } else {
                setTabIndex(1);
            }

        } else {
            setCurrentPage(1);
            setStatus(FILTER_DATA[0]);
            setToggleFilter(false);
            setTabIndex(1);
        }
    }, [state]);

    useEffect(() => {
        if (currentPage !== 0) {
            if (skipListFetchRef.current) {
                skipListFetchRef.current = false;
                return;
            }
            if (tabIndex === 1) {
                _getRewardList();
            } else if (tabIndex === 2) {
                _getMilestoneList()
            } else {
                _getRewardsSettings();
            }
        }
    }, [currentPage, tabIndex, clearFilter]);

    useEffect(() => {
        if (pauseModal === true) {
            const modal = new Modal(document.getElementById('pause-reward-modal'));
            modal.show();
        }
    }, [pauseModal]);

    useEffect(() => {
        if (milestoneModal === true) {
            const reward_modal = new Modal(document.getElementById('add-reward-modal'));
            reward_modal.show();
        }
    }, [milestoneModal]);

    useEffect(() => {
        if (deleteId !== null) {
            const delete_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_modal.show();
        }
    }, [deleteId]);

    // handle paginate store list 
    const _handlePagination = (page_num) => {
        // Ignore RDT's automatic page reset while we handle sort ourselves
        if (isSortingRef.current) {
            isSortingRef.current = false;
            return;
        }

        if (page_num === currentPage) {
            return;
        }

        setCurrentPage(page_num);
        setLoading(true);

        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    const _handleSort = (column, direction) => {
        const sortBy = column.sortField || column.id || null;

        if (!sortBy || !REWARD_SORT_FIELDS.includes(sortBy)) {
            return;
        }

        isSortingRef.current = true;
        setSortField(sortBy);
        setSortDirection(direction);
        setLoading(true);

        // Only skip the list useEffect when page will actually change.
        // If already on page 1, useEffect won't run and a stuck skip flag
        // would block the next pagination API call (loader stuck).
        if (currentPage !== 1) {
            skipListFetchRef.current = true;
        }
        setCurrentPage(1);
        _getRewardList(1, sortBy, direction);

        setTimeout(() => {
            isSortingRef.current = false;
        }, 0);
    };

    // handle tab change 
    const _handleTabChange = (id) => {
        navigate(window.location.pathname, {
            state: {
                ...state,
                tab_index: id
            }
        });
        setLoading(true);

        setSelected(milestoneOptions[0]);
        setStatus(FILTER_DATA[0]);
    };

    const _handleFilter = () => {
        setLoading(true);
        setCurrentPage(1);

        if (tabIndex === 1) {
            _getRewardList(1);
        } else {
            _getMilestoneList(1);
        }
    };


    const _handleClearAll = () => {

        setSelected(milestoneOptions[0]);
        setStatus(FILTER_DATA[0]);
        setSelectedDay(null);
        setEndDate(null);

        setClearFilter(true);
        setLoading(true);
        setCurrentPage(1);
        setSortField(null);
        setSortDirection(null);
    };

    // handle delete milestone 
    const _handleDelete = (id) => {
        setDeleteId(id);
        setDeleteResponse(false);
    };


    // API - Get reward list
    const _getRewardList = (page_num = currentPage, sort_by = sortField, sort_order = sortDirection) => {
        let is_post = true;
        let url = 'CA/rewards/ygg-brands/list';
        let data = {
            "page_num": page_num,
            "limit": ROWS_PER_PAGE,
            "status": status.value === 1 ? true : status.value === 2 ? false : null,
            "sort_by": sort_by ? [sort_by] : null,
            "order": sort_order ? [sort_order] : null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListData(response.data);
            } else {
                setListData({})
            }
            setLoading(false);
            setClearFilter(false);
        });
    };

    // API - Get reward list
    const _download = () => {
        setDownloadLoader(true);
        let is_post = true;
        let url = 'CA/rewards/ygg-brands/download';
        // let data = {
        //     "status": status?.value === 1 ? true : status.value === 2 ? false : null
        // };

        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                const url = response.file_url;
                const link = document.createElement('a');
                link.href = url;
                link.download = '';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setDownloadLoader(false);
        });
    };

    // API - Get profile api
    const _getProfile = () => {
        let is_post = false;
        let url = adminType === "super_admin" ? 'profile/get' : 'CA/profile/get';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'UPDATE_PROFILE_DATA',
                    payload: response.data
                });
            } else { }
        });
    };


    // API - Create milestone 
    const _getMilestoneFilter = () => {
        let is_post = false;
        let url = 'CA/milestone/filter';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setMilestoneFilterData(response.data);
                // setMilestoneModal(true);
                const milestone_options = []
                milestone_options.push({ label: "All", value: null })
                response.data.milestone_types.map((item) => {
                    return (
                        milestone_options.push(item)
                    )
                })
                setMilestoneOptions(milestone_options);
                setSelected(milestone_options[0]);
            } else {

            }
        });
    };

    // API - Get milestone list 
    const _getMilestoneList = (page_num = currentPage) => {
        let is_post = true;
        let url = 'CA/milestone/list';
        let data = {
            "page_num": page_num,
            "limit": ROWS_PER_PAGE,
            "type": selected?.value || null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setMilestoneData(response.data);
            } else {
                setMilestoneData({});
            }
            setLoading(false);
            setClearFilter(false);
        });
    };

    // API - Get rewards settings (point conversion rule)
    const _getRewardsSettings = () => {
        let is_post = false;
        let url = 'CA/rewards/settings/get';

        APIService(is_post, url).then((response) => {
            if ((response.success || response.status_code === 200) && response.data.currencies?.length > 0) {
                const settings = response.data.currencies.map((item) => ({
                    currency: item.currency ?? "",
                    currency_value: item.currency_value ?? "",
                    points: item.points ?? "",
                    updated_at: item.updated_at ?? "",
                    error: ""
                }));
                setSettingsList(settings);
            } else {
                setSettingsList([]);
            }
            setLoading(false);
        });
    };

    // handle change of a settings row input (clears its validation error)
    const _handleSettingChange = (index, field, value) => {
        setSettingsList((prev) => prev.map((item, i) =>
            i === index ? { ...item, [field]: value, error: "" } : item
        ));
    };

    // API - Update rewards settings (point conversion rule)
    const _updateRewardsSettings = (index) => {
        const row = settingsList[index];

        // validation - currency value and points must not be empty
        if (row.currency_value === "" || row.points === "") {
            setSettingsList((prev) => prev.map((item, i) =>
                i === index ? { ...item, error: "Currency value and points are required" } : item
            ));
            return;
        }

        setSaveLoaderIndex(index);
        let is_post = true;
        let url = 'CA/rewards/settings/update';
        let data = {
            "currency": row.currency,
            "currency_value": Number(row.currency_value),
            "points": Number(row.points)
        };

        APIService(is_post, url, data).then((response) => {
            toast.dismiss();
            if (response.success || response.status_code === 200) {
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });
                _getRewardsSettings();
            } else {
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setSaveLoaderIndex(null);
        });
    };

    // API - Delete milestone
    const _deleteMilestone = (id) => {
        let is_post = true;
        let url = 'CA/milestone/delete';
        let data = {
            "milestone_id": id
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setDeleteResponse(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
                setDeleteResponse(false);
            }
        });
    };

    const TABLE_COLUMNS = [
        {
            name: 'Reward title',
            id: 'brand_title',
            sortField: 'brand_title',
            selector: row => row.brand_title,
            cell: row => <div className='py-2 pe-1'>{row.brand_title}</div>,
            width: "360px",
            sortable: true,
        },
        // {
        //     name: 'Start date',
        //     selector: row => row.start_date || "-",
        //     cell: row => <>{row.start_date || "-"}</>,
        //     width: "120px",
        //     format: row => row.start_date,
        //     sortable: true,
        // },
        // {
        //     name: 'Expiry date',
        //     selector: row => row.end_date || "-",
        //     cell: row => <>{row.end_date || "-"}</>,
        //     format: row => row.end_date,
        //     width: "120px",
        //     sortable: true,
        // },
        {
            name: 'Validity',
            id: 'validity_in_months',
            sortField: 'validity_in_months',
            selector: row => row.validity_in_months,
            cell: row =>
                <span >
                    {`${row.validity_in_months} ${row.validity_in_months > 1 ? "Months" : "Month"}`}
                </span>,
            width: "140px",
            sortable: true,
        },
        {
            name: 'Total redeemed users',
            id: 'total_redeemed_users',
            sortField: 'total_redeemed_users',
            selector: row => row.total_redeemed_users || "-",
            width: "190px",
            sortable: true,
        },
        {
            name: 'Status',
            id: 'status',
            sortField: 'status',
            cell: row =>
                <span className={`${row.status === true ? "e-text-philippine-green " : "e-text-boston-university-red"} e-font-weight-600`}>
                    {row.status === true ? "Active" : "Inactive"}
                </span>,
            width: "100px",
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => <>
                <TextButton name="View"
                    className="w-max-content e-font-weight-400"
                    icon={true}
                    onPress={() => {
                        navigate("detail", {
                            state: {
                                id: row.id,
                                current_page: currentPage,
                                status: status,
                                toggle: toggleFilter
                            }
                        })
                    }}
                />
            </>,
            width: "80px"
        }
    ];

    // milestone list table columns
    const TABLE_COLUMNS_MILESTONE = [
        {
            name: 'Created on',
            selector: row => row.created_on,
            width: "120px",
            cell: row => <>{row.created_on}</>,
            format: row => row.created_on,
            sortable: true
        },
        {
            name: 'Type',
            selector: row => row.milestone_type,
            width: "160px",
            sortable: true
        },
        {
            name: 'Details',
            selector: row => row.sales_type !== null ? row.sales_type : '-',
            width: "160px",
            sortable: true
        },
        {
            name: (
                <>
                    <p className='mb-0'>Volume<span className='e-font-weight-400 ps-1'>{PROFILE_DATA.country === "Egypt" ? '(Units)' : '(Ltr)'}</span></p>
                </>
            ),
            selector: row => row.sales_per_unit !== null ? row.sales_per_unit : '-',
            width: "160px",
            sortable: true
        },
        // {
        //     name: 'Painters visited',
        //     selector: row => row.visited_painters !== null ? row.visited_painters : '-',
        //     width: "150px"
        // },
        {
            name: 'Points earned',
            selector: row => row.reward_points !== null ? row.reward_points : '-',
            width: "180px",
            sortable: true
        },
        {
            name: '',
            cell: (row) =>
                <div className="d-flex">
                    <PrimaryButton name="Delete"
                        className="padding-6px-tb padding-14px-lr e-reject"
                        onPress={() => _handleDelete(row.reward_id)} />
                </div>,
        }
    ];

    return (
        <section className='pb-5 '>
            <div className='e-bg-lavender-blush-light padding-12px-top padding-98px-bottom padding-52px-lr'>
                <h1 className='mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-rich-black e-font-weight-600'>
                    Rewards
                </h1>
            </div>
            <div className='margin-neg-66px-top padding-52px-lr'>
                <div ref={scrollRef} className='e-bg-white e-border-1px-platinum-dark e-admin-box-shadow py-4 e-border-radius-16'>
                    <div className='px-3'>
                        <div className='pb-3 d-flex align-items-center justify-content-between'>
                            <div className='d-flex gap-3 align-items-center'>

                                {TAB_DATA.map((tab) => (
                                    <CustomTab key={tab.id}
                                        data={tab}
                                        tabIndex={tabIndex}
                                        handleTabChange={_handleTabChange} />
                                ))}
                            </div>

                            {tabIndex !== 3 &&
                                <div className='d-flex align-items-center gap-4'>
                                    {tabIndex === 1 ?
                                        <>
                                            <DownloadButton loader={downloadLoader}
                                                disabled={loading || Object.keys(listData)?.length === 0 || listData?.brands?.length === 0}
                                                onClick={_download} />

                                            <SecondaryButton name={isPause ? "Resume rewards" : "Pause rewards"}
                                                className="e-border-radius-8"
                                                disabled={Object.keys(listData).length === 0 || listData?.brands?.length == 0}
                                                padding="padding-10px-tb padding-12px-lr"
                                                onPress={() => setPauseModal(true)}
                                            />
                                        </>
                                        :
                                        <PrimaryButton name="Add new milestone"
                                            className="py-2 e-border-radius-16 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-2"
                                            onPress={() => setMilestoneModal(true)} />
                                    }


                                    <img src={toggleFilter ? require("../../../Assets/Image/filter-icon-white.svg").default : require("../../../Assets/Image/filter-icon.svg").default}
                                        draggable={false}
                                        className={`${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-anti-flash-white e-border-radius-8 p-2 cursor-pointer`}
                                        alt='filter'
                                        onClick={() => setToggleFilter(!toggleFilter)} />
                                </div>
                            }
                        </div>
                    </div>

                    {/* filter */}
                    {toggleFilter &&
                        <div className='e-bg-anti-flash-white-dark py-3 px-4'>
                            {tabIndex === 1 ?
                                <div className='row gx-3'>
                                    <div className='col-3'>
                                        <CustomSelectBox label="Status"
                                            value={status}
                                            options={FILTER_DATA}
                                            type={2}
                                            optional={true}
                                            className="e-bg-white e-border-radius-4 e-table-select"
                                            minHeight="34px"
                                            padding="0 8px"
                                            wrapperHeight="0px"
                                            labelClass="e-font-weight-600"
                                            isSearchable={false}
                                            selectChange={(value) => {
                                                setStatus(value);
                                            }}
                                        />
                                    </div>

                                    {/* <div className='col-md-3 col-sm-4 col-6'>
                                        <p className='mb-0 e-text-dark-black e-alt-font-noto-sans e-font-14 e-font-weight-600 line-height-20px d-flex'>
                                            Date of joining
                                        </p>
                                        <div className='pt-1 row'>
                                            <div className='position-relative '>
                                                <div className={`${dateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} e-display-flex gap-0-4px justify-content-between e-border-radius-4 p-2 cursor-pointer e-bg-white`}
                                                    onClick={() => setDateToggle(!dateToggle)}>

                                                    {selectedDay !== null ?
                                                        <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                            {format(selectedDay, 'PP')}
                                                        </p>
                                                        :
                                                        <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                            From
                                                        </p>
                                                    }
                                                    <div className='d-flex' onClick={(e) => e.stopPropagation()}>
                                                        {selectedDay === null ?
                                                            <img src={require("../../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                                draggable={false}
                                                                width={16}
                                                                height={16}
                                                                alt='calender-icon' />

                                                            :
                                                            < Icon icon="close-icon"
                                                                className='cursor-pointer d-flex'
                                                                size={16}
                                                                onPress={() => {
                                                                    setSelectedDay(null);
                                                                    setEndDate(null);
                                                                }} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {dateToggle &&
                                            <>
                                                <OverLay className="e-bg-overlay " isOpen={dateToggle} onClose={() => setDateToggle(!dateToggle)} />
                                                <CustomDatePicker selected={selectedDay}
                                                    className='e-day-picker w-358px position-absolute e-bg-white e-border-radius-16 z-index-99'
                                                    disableFuture={true}
                                                    onSelect={(day) => {
                                                        setSelectedDay(day);
                                                        setDateToggle(false);
                                                        setEndDate(null);
                                                    }} />
                                            </>
                                        }
                                    </div>

                                    <div className='col-md-3 col-sm-4 col-6 mt-auto position-relative'>

                                        <div className='pt-1 row'>
                                            <div className='position-relative '>
                                                <div className={`${endDateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} e-display-flex gap-0-4px justify-content-between e-border-radius-4 p-2 cursor-pointer e-bg-white`}
                                                    onClick={() => setEndDateToggle(!endDateToggle)}>

                                                    {endDate !== null ?
                                                        <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                            {format(endDate, 'PP')}
                                                        </p>
                                                        :
                                                        <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                            To
                                                        </p>
                                                    }
                                                    <div className='d-flex' onClick={(e) => e.stopPropagation()}>
                                                        {endDate === null ?
                                                            <img src={require("../../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                                draggable={false}
                                                                width={16}
                                                                height={16}
                                                                alt='calender-icon' />

                                                            :
                                                            < Icon icon="close-icon"
                                                                className='cursor-pointer d-flex'
                                                                size={16}
                                                                onPress={() => setEndDate(null)} />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {endDateToggle &&
                                            <>
                                                <OverLay className="e-bg-overlay " isOpen={endDateToggle} onClose={() => setEndDateToggle(!endDateToggle)} />
                                                <CustomDatePicker selected={endDate}
                                                    className='e-day-picker w-358px end-0 position-absolute e-bg-white e-border-radius-16 z-index-99'
                                                    disableFuture={true}
                                                    minDate={selectedDay}
                                                    onSelect={(day) => {
                                                        setEndDate(day);
                                                        setEndDateToggle(false);
                                                    }} />
                                            </>
                                        }
                                    </div> */}

                                    <div className='d-flex gap-3 align-items-center justify-content-end'>
                                        <TextButton name="Clear all"
                                            onPress={_handleClearAll} />
                                        <PrimaryButton name="Filter now"
                                            className="px-3 py-1 e-border-radius-8"
                                            onPress={_handleFilter} />
                                    </div>
                                </div>
                                :
                                <div className='row g-3'>
                                    <div className='col-lg-3 col-md-3 col-sm-4 col-8'>
                                        <CustomSelectBox label="Select type"
                                            value={selected}
                                            options={milestoneOptions}
                                            type={2}
                                            optional={true}
                                            className="e-bg-white e-border-radius-4 e-table-select"
                                            minHeight="34px"
                                            padding="0 8px"
                                            wrapperHeight="0px"
                                            labelClass="e-font-weight-600"
                                            isSearchable={false}
                                            selectChange={(temp) => { setSelected(temp); }}
                                        />
                                    </div>

                                    <div className='col-lg-3 col-md-3 col-sm-4 col-8 mt-auto'>
                                        <div className='d-flex gap-3 align-items-center justify-content-end'>
                                            <TextButton name="Clear all"
                                                onPress={_handleClearAll} />
                                            <PrimaryButton name="Filter now"
                                                className="px-3 py-1 e-border-radius-8"
                                                onPress={_handleFilter} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    {loading ?
                        // loader 
                        <Loader />
                        :
                        <>
                            {tabIndex === 3 ?
                                // Rewards settings - point conversion rule
                                <div className='px-3'>
                                    <div className='e-bg-white e-border-1px-platinum-dark p-4'>
                                        <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-16 e-font-weight-500 line-height-24px'>
                                            Point conversation rule
                                        </p>
                                        <p className='mb-0 pt-1 e-text-raisin-black e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-24px'>
                                            This rule determines how reward points are earned based on sales value.
                                        </p>

                                        {settingsList.length !== 0 ?
                                            settingsList.map((item, index) => (
                                                <div key={index} className='pt-4'>
                                                    <div className='d-flex align-items-center flex-wrap gap-3'>
                                                        {/* currency value */}
                                                        <div className='e-border-1px-platinum-dark e-border-radius-8 d-flex align-items-center justify-content-between px-3' style={{ height: "44px", width: "208px" }}>
                                                            <input value={item.currency_value}
                                                                type="number"
                                                                className='border-0 e-bg-white e-font-16 e-text-raisin-black e-font-weight-500 line-height-24px e-alt-font-noto-sans w-100 me-2'
                                                                onWheel={() => document.activeElement.blur()}
                                                                onChange={(e) => _handleSettingChange(index, "currency_value", e.target.value)} />
                                                            <span className='e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-24px'>
                                                                {item.currency}
                                                            </span>
                                                        </div>

                                                        {/* swap icon */}
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#212121" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
                                                        </svg>

                                                        {/* points value */}
                                                        <div className='e-border-1px-platinum-dark e-border-radius-8 d-flex align-items-center justify-content-between px-3' style={{ height: "44px", width: "208px" }}>
                                                            <input value={item.points}
                                                                type="number"
                                                                className='border-0 e-bg-white e-font-16 e-text-raisin-black e-font-weight-500 line-height-24px e-alt-font-noto-sans w-100 me-2'
                                                                onWheel={() => document.activeElement.blur()}
                                                                onChange={(e) => _handleSettingChange(index, "points", e.target.value)} />
                                                            <span className='e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-24px'>
                                                                Points
                                                            </span>
                                                        </div>

                                                        {/* save */}
                                                        <PrimaryButton name="Save"
                                                            className="padding-12px-tb px-4 e-border-radius-16"
                                                            status={saveLoaderIndex === index}
                                                            onPress={() => _updateRewardsSettings(index)} />
                                                    </div>

                                                    {/* validation error */}
                                                    {item.error &&
                                                        <p className='mb-0 pt-1 e-text-boston-university-red e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-24px'>
                                                            {item.error}
                                                        </p>
                                                    }

                                                    {item.updated_at &&
                                                        <p className='mb-0 pt-2 e-text-raisin-black e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-24px'>
                                                            Last updated:{item.updated_at}
                                                        </p>
                                                    }
                                                </div>
                                            ))
                                            :
                                            <div className='pt-4'>
                                                <EmptyScreen message="No data found" />
                                            </div>
                                        }
                                    </div>
                                </div>
                                : tabIndex === 1 ?
                                <>
                                    {/* Store detail data table */}
                                    {Object.keys(listData).length !== 0 && listData.brands.length !== 0 ?
                                        <div className='e-table e-store-table e-reward-table'>
                                            <DataTableComponent
                                                key={`rewards-table-${currentPage}-${sortField || 'none'}-${sortDirection || 'none'}`}
                                                columns={TABLE_COLUMNS}
                                                data={listData.brands}
                                                pagination={true}
                                                paginationServer={true}
                                                paginationPerPage={ROWS_PER_PAGE}
                                                paginationTotalRows={listData.total_count}
                                                paginationDefaultPage={currentPage}
                                                paginationResetDefaultPage={false}
                                                sortServer={true}
                                                defaultSortFieldId={sortField}
                                                defaultSortAsc={sortDirection !== 'desc'}
                                                onSort={_handleSort}
                                                onChangePage={_handlePagination}
                                            // rowClick={(row) => _handleNavigateDetail(row)}
                                            />
                                        </div>
                                        :
                                        // empty screen
                                        <div className='h-100vh py-5 my-5'>
                                            <EmptyScreen message="No data found" />
                                        </div>
                                    }
                                </>
                                :
                                <>
                                    {Object.keys(milestoneData).length !== 0 && milestoneData.data.length !== 0 ?
                                        <div className='e-table'>
                                            <DataTableComponent columns={TABLE_COLUMNS_MILESTONE}
                                                data={milestoneData.data}
                                                pagination={true}
                                                paginationServer={true}
                                                paginationPerPage={ROWS_PER_PAGE}
                                                paginationTotalRows={milestoneData.total_rows}
                                                paginationDefaultPage={currentPage}
                                                onChangePage={_handlePagination} />
                                        </div>
                                        :
                                        // empty screen
                                        <div className='h-100vh pt-5 mt-5'>
                                            <EmptyScreen message="No milestones found" />
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </div>
            </div>



            {pauseModal === true &&
                <PauseRewardModal title={isPause ? "Resume reward?" : "Pause reward?"}
                    description={isPause ? "Resuming this reward will allow users to start earning and redeeming it again. The reward will become active immediately." :
                        <>
                            Pausing this reward will temporarily stop users from earning and redeeming it.
                            The reward details and history will remain visible.
                            <div className='pt-2'>You can resume this reward anytime.</div>
                        </>}
                    primaryButtonLabel={isPause ? "Resume reward" : "Pause reward"}
                    handleClose={() => {
                        setTimeout(() => {
                            setPauseModal(false);
                        }, 200);
                    }}

                    handleSuccess={() => {
                        setTimeout(() => {
                            setPauseModal(false);
                            setIsPause(prev => !prev);
                            _getProfile();
                        }, 200);
                    }}
                />
            }

            {/* add reward modal */}
            {milestoneModal === true &&
                <AddRewardsModal data={milestoneFilterData}
                    handleClose={() => setMilestoneModal(false)}
                    success={() => {
                        _getMilestoneList(1);
                        setLoading(true);
                    }} />
            }

            {/* delete modal  */}
            {deleteId !== null &&
                <ConfirmDeleteModal label="milestone"
                    deleteId={deleteId}
                    delete={(id) => _deleteMilestone(id)}
                    handleClose={() => setDeleteId(null)}
                    success={() => {
                        if (currentPage > 1 && Object.keys(milestoneData).length !== 0 && milestoneData.data.length === 1) {
                            setCurrentPage(currentPage - 1)
                        } else {
                            _getMilestoneList(1)
                        }
                        setLoading(true);
                    }}
                    response={deleteResponse} />
            }
        </section>
    )
}

export default RewardList;
